<template>
  <div class="upload-desc-wrap">
    <el-upload v-if="edit"
      ref="upload"
      class="upload-desc"
      :action="picUrl"
      accept="image/*,.mp4,.ogg,.webm"
      multiple
      :limit="20"
      :file-list="value"
      :show-file-list="false"
      :on-success="handleDescSuccess"
      :on-error="handleError"
      :on-exceed="handleDescExceed">
      <el-button size="small"
        type="primary">点击上传</el-button>
    </el-upload>
    <draggable v-if="edit"
      class="el-upload-list el-upload-list--text"
      element="ul"
      v-model="myList"
      :options="dragOptions">
      <li class="el-upload-list__item is-success"
        style="cursor: move;"
        v-for="(item,index) in myList"
        :key="item.url">
        <a class="el-upload-list__item-name">
          <i class="el-icon-rank"></i>
          <i class="el-icon-document"></i>{{item.name | getFilename()}}
        </a>
        <label class="el-upload-list__item-status-label">
          <i class="el-icon-upload-success el-icon-circle-check"></i>
        </label>
        <i class="el-icon-close"
          @click="deleteDesc(item,index)"></i>
      </li>
    </draggable>
    <div class="detail-phone">
      <div class="phone-inner">
        <template v-for="(item, index) in value">
          <img v-if="item.mediaType === 1"
            :key="index"
            :src="item.url | imageFixed(375)">
          <video style="width: 100%"
            controls
            v-if="item.mediaType === 2"
            :key="index"
            :src="item.url">
          </video>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Common from '@/service/common'
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  name: 'descImages',
  components: { draggable },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      picUrl: Common.picServerUrl,
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      }
    }
  },
  computed: {
    myList: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    handleDescSuccess (res, file) {
      console.log('handleDescSuccess', file)
      console.log(JSON.stringify(this.$refs.upload.uploadFiles))
      this.$refs.upload.uploadFiles.forEach(item => {
        if (item.uid === file.uid) {
          item.url = res.viewUrl + res.filepath
          item.mediaType = file.raw.type.indexOf('video') > -1 ? 2 : 1
        }
      })
      // let list = _.cloneDeep(this.value)
      // list.push({
      //   ...file,
      //   url: res.viewUrl + res.filepath,
      //   name: file.name,
      //   mediaType: file.raw.type.indexOf('video') > -1 ? 2 : 1
      // })
      this.$emit('input', this.$refs.upload.uploadFiles)
    },
    handleDescExceed (files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    deleteDesc (item, index) {
      let list = _.cloneDeep(this.value)
      list.splice(index, 1)
      this.$emit('input', list)
    },
    handleError (err, file) {
      console.log(err)
      this.$message.error('上传失败')
    }
  }
}
</script>
<style lang="stylus">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.upload-desc-wrap {
  .upload-desc {
    .el-upload-list {
      display: none;
    }
  }

  .el-upload-list__item-name, .el-upload-list__item-name * {
    cursor: grab !important;
  }

  .detail-phone {
    // margin: 10px auto 0;
    width: 377px;
    height: 669px;
    border: 1px solid #454553;
    background: url('../../assets/images/mobi.png') left top / 377px 669px no-repeat;

    .phone-inner {
      width: 100%;
      height: calc(100% - 64px);
      margin-top: 64px;
      overflow: auto;

      img {
        max-width: 100%;
        vertical-align: top;
      }
    }
  }
}
</style>
